import { render, staticRenderFns } from "./InboxActions.vue?vue&type=template&id=f7d3d094"
import script from "./InboxActions.vue?vue&type=script&lang=js"
export * from "./InboxActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports